<template>
  <a
    :class="classes"
    :style="styles"
    href="/subscribe/checkout"
  >
    {{ text }}
  </a>
</template>

<script>
export default {
  props: ['color', 'text', 'classes'],
  computed: {
    styles() {
        if(this.color) {
            return `background-color: ${this.color}; border-color: ${this.color};`
        }
        return ''
    },
  },
}
</script>

<style></style>
